import { 
    apiRequest,
    AwardCreate
 } from '../../../../../services/adapters/kepegawaian/penghargaanService'

class AwardRepository {

    fetchCreate = async (query) => {
        return await apiRequest('post', AwardCreate, {
            body: query
        }, true)
    }
 
}

export default AwardRepository